import { render, staticRenderFns } from "./nav-tag.vue?vue&type=template&id=69b06d69&"
import script from "./nav-tag.vue?vue&type=script&lang=ts&"
export * from "./nav-tag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports